import * as React from 'react';

import { Container } from 'reactstrap';
import { css, StyleSheet } from 'aphrodite';
import Page from './Page';
import View from './View';
import theme from '../theme';
import { mpTrackingScreens } from '../config/screens';
import newtheme from '../newtheme';
import LandingPageNewSitemap from './landingpagenew/LandingPageNewSitemap';

interface IProps {
    showSitemap: boolean;
}
class Privacy extends React.Component<IProps, {}> {
    public render() {
        return (
            <Page className={css(styles.page)} title="Privacy Policy" trackingScreen={mpTrackingScreens.privacy}>
                <Container>
                    <View>
                        <h1 className={css(styles.title)}>Privacy Policy</h1>

                        <p>
                            {' '}
                            Noa provides this Privacy Policy to help you make an informed decision about whether to use or continue using the Noa Service. If you do not agree to our practices, please
                            do not use the Noa Service.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            This Privacy Policy is incorporated into and is subject to the Noa Terms and Conditions of Use. Your use of the Noa Service and any personal information you provide on the
                            Noa Service remains subject to the terms of this Privacy Policy and our Terms and Conditions of Use.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 1. Definitions </h3>
                        <p>
                            {' '}
                            Before you continue we would like you to familiarise yourself with the following definitions in order to help you understand each of the terms detailed on this document.
                            For all items not listed in this section, we will define their definition in the body of the text in a clear and concise manner.
                            {' '}
                        </p>
                        <div style={{ overflowX: 'auto' }}>
                            <table>
                                <tbody>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Content&quot; : </p>
                                        </th>
                                        <td>
                                            <p> Refers to any material(s) distributed as part of the Noa Service, including those which are text, graphic, numeric, video, or audio based. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Customer&quot; or &quot;user&quot; or &quot;you&quot; :</p>
                                        </th>
                                        <td>
                                            <p> Refers to any anyone registering or subscribing to, or making use of, the Noa Service. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Enterprise Subscriber&quot;:</p>
                                        </th>
                                        <td>
                                            <p>
                                                {' '}
                                                Refers to a user who is granted access to the Noa Service as a result of payment made on their behalf by an organisation, as part of a group
                                                subscription.
                                                {' '}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Noa&quot; or &quot;we&quot; or &quot;our&quot;:</p>
                                        </th>
                                        <td>
                                            <p>
                                                {' '}
                                                Refers to Noa News Limited, a company registered in Ireland under company registration number 564767 and all subsidiaries and affiliates acting on
                                                behalf of Noa News Limited. A list of subsidiaries and affiliates are available upon request by using the contact form on our website.
                                                {' '}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Noa Service&quot; or &quot;Service&quot; : </p>
                                        </th>
                                        <td>
                                            <p>
                                                {' '}
                                                Refers to the provisioning of Content to Customers across Noa’s smartphone and tablet applications, audio players, websites, and any other digital or
                                                non-digital offerings that may be available from time to time (collectively, the &quot;Noa Site&quot;).
                                                {' '}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Publisher&quot; : </p>
                                        </th>
                                        <td>
                                            <p> Refers to a publisher whose Content is distributed by Noa. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Personal Information&quot; :</p>
                                        </th>
                                        <td>
                                            <p>
                                                {' '}
                                                Refers to any information that you, or an organisation or other party that pays for access to the Noa Service on your behalf, shares with Noa, that can
                                                be used to identify you (e.g. email addresses, name, place of residence, etc.) and any billing information that you provide to Noa. This also includes
                                                any data gathered by Noa as a result of your activity on the Service. This does not include any information that you provide to any third-party while
                                                using the Noa Service.
                                                {' '}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Post&quot; :</p>
                                        </th>
                                        <td>
                                            <p> Any Content that users post, share, upload, and/or contribute to the Service. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Subscriber&quot;: </p>
                                        </th>
                                        <td>
                                            <p>
                                                {' '}
                                                Refers to a user who is granted access to the Noa Service as a result of direct payment from that user, or payment made on their behalf by another
                                                individual, by way of a gift.
                                                {' '}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Subscription&quot;: </p>
                                        </th>
                                        <td>
                                            <p> Refers to any subscription tier offered by Noa that provides access to the Noa Service, including group subscriptions. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;Subscription Period&quot;: </p>
                                        </th>
                                        <td>
                                            <p> Refers to the length of a Subscription </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className={css(styles.tableHeader)}>
                                            <p>&quot;User Content&quot;: </p>
                                        </th>
                                        <td>
                                            <p>
                                                {' '}
                                                Refers to comments, URLs or other links, messages, information, playlist compilations, and/or other types of content that you or other Noa users may
                                                Post.
                                                {' '}
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <h3 className={css(styles.sectionTitle)}> 2. Your consent </h3>
                        <p> By the continued use of our Services or by becoming a Subscriber you consent to the use of your personal information in accordance with this Privacy Policy. </p>
                        <p>
                            {' '}
                            Please note that any User Content that users Post to the Noa Service becomes published content and is not considered personally identifiable information subject to this
                            Privacy Policy.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 3. What Does This Privacy Policy Cover? </h3>
                        <p>
                            {' '}
                            This Privacy Policy is part of Noa Terms and Conditions of Use and covers the treatment of user information, including Personal Information, obtained by Noa, including
                            information obtained when you access the Noa Service or any other application, website, or software provided by Noa.
                            {' '}
                        </p>
                        <p>
                            {' '}
                            This Privacy Policy does not apply to the practices of companies that Noa does not own or control, or to individuals whom Noa does not employ or manage, including any of
                            the third parties to which Noa may disclose user information as set forth in this Privacy Policy.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 4. The Information Noa Collects </h3>
                        <p>
                            {' '}
                            Noa may obtain the following types of information from or concerning you or your mobile phone device, PC, or tablet computer which may include Personal Information that can
                            be used to identify you as specified below:
                            {' '}
                        </p>
                        <p>
                            <strong>4.1 User Provided Information:</strong>
                            {' '}
                            You provide certain Personal Information, such as your email address, name, age, billing details and mobile device
                            information to Noa when choosing to participate in various uses of the Noa Service (whether as a non-paying or Subscriber user). This information is used by Noa to allow
                            you to login, to ensure that content that is displayed is age suitable, for VAT purposes, and for the overall performance of the Service.
                            {' '}
                        </p>
                        <p>
                            <strong>4.2 Log File Information &amp; Cookies:</strong>
                            {' '}
                            When you use the Noa Site, our servers automatically record certain information that your web browser sends
                            whenever you visit any website. These server logs may include information such as your web request, Internet Protocol (&quot;IP&quot;) address, browser type, browser language,
                            referring / exit pages and URLs, platform type, number of clicks, domain names, landing pages, pages viewed and the order of those pages, the amount of time spent on
                            particular pages, the date and time of your request. When you use the Noa Service, our servers may log certain information that our software application sends whenever (a)
                            an article is listened to in part or in full and (b) an audio or display advertisement is served, including your devices country code, date and time stamps, and the
                            duration of time that certain information is playing or displayed (collectively &quot;Usage Data&quot;).
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 5. The Information Noa Does Not Collect </h3>
                        <p>
                            {' '}
                            Noa does not collect or have access to any payment details that you may enter when purchasing a Subscription on the Noa Site. Instead this information is processed and
                            stored by Stripe, Inc., a San Francisco, USA based online payments company.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 6. How long do we keep your personal information? </h3>
                        <p>
                            {' '}
                            We will only retain your personal data for as long as necessary to fulfil the purposes for which we collected it. Your personal data may be retained by us for a longer
                            period if required by law. Some of your personal data may need to be retained because of circumstances such as a legal dispute or regulatory investigation, which would
                            usually mean that a longer retention period is required.
                            {' '}
                        </p>
                        <p> The below table provides a summary of how long personal information is retained: </p>
                        <div style={{ overflowX: 'auto' }}>
                            <table className={css(styles.personalInfoTable)}>
                                <tbody>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Data Type</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Example</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Retention Period</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Justification for Retaining</strong>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Billing information</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Most recently used payment details </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> 7 years </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> For regulatory reasons we are required to retain accounting records for 7 years. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Business intelligence</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Subscriber activity on Noa Site </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> 36 months (then aggregated + non-personally identifiable) </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                {' '}
                                                To personalise our service according to user requirements and to analyse trends and performance that feed contribute to product maintenance and
                                                improvement.
                                                {' '}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>User Content</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> User generated comments </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Life of the User Content </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> To enable our users to view the comments of other users. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Customer service communications</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Feedback on the Noa Site and Content </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> 7 years </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Case history records to assist customers. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Communication history</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Emails announcing new publishers </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> 7 years </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Adequate records of all dialogue to better understand what has been communicated. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Event registration</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Sign-in for a Noa speaker series </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> 13 – 36 months </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> For future event invites, event feedback and analysis. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Market research</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Survey results on user experiences </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> 13 months (then aggregated + non-personally identifiable) </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> To effectively execute marketing projects and for historical comparisons of marketing data. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Site features</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Favourited articles </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Lifetime of users account </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> To facilitate the continuation of features for users and to analyse trends and performance to feed maintenance and improvements. </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p>
                                                <strong>Subscription information</strong>
                                            </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> Details on subscription term </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> 7 years post-subscription </p>
                                        </td>
                                        <td className={css(styles.tableCellVerticalAlign)}>
                                            <p> To allow for the fulfilment of our agreement with subscribers. </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <h3 className={css(styles.sectionTitle)}> 7. The Way Noa Uses Information </h3>
                        <p>
                            {' '}
                            We use any information that you provide to us to operate, maintain, and provide to you the features and functionality of the Noa Service. In particular, your email address
                            may be used to access additional features of the Noa Service. Any personally identifiable information or User Content that you voluntarily disclose on the Noa Service in a
                            public forum becomes publicly available and may be collected and used by other users of the Noa Service – for this reason we advise caution when sharing Posts. We do not
                            share your Personal Information (e.g. your email address or name) to any third-parties. We may send you Noa-related emails, but only ever as part of a specific program or
                            feature for which you will have the ability to opt-in or opt-out. Such emails may include a daily or weekly newsletter or emails that detail new or existing in-app features
                            or offers which we believe you may be interested in. We will also use your email address for non-marketing or administrative purposes (such as notifying you of major Noa
                            Service changes or for customer service purposes). We may use certain non-personally-identifiable information (such as anonymous Usage Data, IP addresses, etc.) to improve
                            the quality and design of the Noa Service and to create new features, promotions, functionality, and services by storing, tracking, and analysing user preferences and
                            trends. We may use log file information to monitor individual and aggregate metrics such as total number of visitors, pages viewed, articles listened, for example.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 8. When Noa Discloses Information </h3>
                        <p> Other users of the Noa Service will not see any of your Personal Information. </p>
                        <p> If you are an Enterprise Subscriber, we will provide the organisation paying your subscription, with personal information for the purpose of billing and reporting. </p>
                        <p> If you register for the Noa Service with a social media account, we may share your social media account identification details with social media platforms in order to: </p>
                        <ul>
                            <p>
                                <li>Promote subscriber’s engagement to ensure they get the most of their subscription;</li>
                            </p>
                            <p>
                                <li>Prevent subscription offers being targeted at existing subscribers on social media platforms.</li>
                            </p>
                            <p>
                                <li>Facilitate the creation of lookalike audiences to assist in targeted advertising on social media platforms.</li>
                            </p>
                        </ul>
                        <p>
                            {' '}
                            We do not share your Personal Information (such as your email address, name, or date of birth) with any other third-party companies, organisations, or individuals. We will
                            not sell your Personal Information to third-party companies, organisations, or individuals. We may share non-personally-identifiable information (such as anonymous Usage
                            Data, referring/exit pages and URLs, platform types, number of clicks, etc.) with interested third-parties to assist them in understanding the usage patterns for certain
                            content, services, advertisements, promotions, and/or functionality on the Noa Service. We may collect and release Personal Information and/or non-personally-identifiable
                            information if required to do so by law, or in the good-faith belief that such action is necessary to comply with national or international law or respond to a court order,
                            subpoena, or search warrant or equivalent, or where in our reasonable belief, an individual’s physical safety may be at risk or threatened. NOA ALSO RESERVES THE RIGHT TO
                            DISCLOSE PERSONAL INFORMATION AND/OR NON-PERSONALLY-IDENTIFIABLE INFORMATION THAT NOA BELIEVES, IN GOOD FAITH, IS APPROPRIATE OR NECESSARY TO ENFORCE OUR TERMS AND
                            CONDITIONS OF USE, TAKE PRECAUTIONS AGAINST LIABILITY, TO INVESTIGATE AND DEFEND ITSELF AGAINST ANY THIRD-PARTY CLAIMS OR ALLEGATIONS, TO ASSIST GOVERNMENT ENFORCEMENT
                            AGENCIES, TO PROTECT THE SECURITY OR INTEGRITY OF THE NOA SERVICE OR OUR SERVERS, AND TO PROTECT THE RIGHTS, PROPERTY, OR PERSONAL SAFETY OF NOA, OUR USERS OR OTHERS.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 9. Your Choices and Rights </h3>
                        <p>
                            {' '}
                            You may, of course, decline to submit Personal Information through the Noa Service, in which case Noa may not be able to provide certain of our Services to you. If you do
                            not agree with our Privacy Policy or Terms and Conditions of Use please discontinue use of the Noa Service, delete your account (if applicable), and uninstall the Noa
                            mobile or tablet application. Your continued usage of the Noa Service will signify your assent to and acceptance of our Privacy Policy and Terms and Conditions of Use.
                            {' '}
                        </p>
                        <p> You have certain rights regarding the personal data that we have about you; however, you should note that these rights can be subject to some exceptions: </p>
                        <ul>
                            <p>
                                <li>Delete Data: You can ask us to erase or delete all or some of your personal data.</li>
                            </p>
                            <p>
                                <li>Change or Correct Data: You can ask us to change, update or fix your data in certain cases, particularly if it’s inaccurate.</li>
                            </p>
                            <p>
                                <li>
                                    Object to, or Limit or Restrict, Use of Data: You can ask us to stop using all or some of your personal data (e.g., if we have no legal right to keep using it) or
                                    to limit our use of it (e.g., if your personal data is inaccurate or unlawfully held).
                                </li>
                            </p>
                            <p>
                                <li>
                                    Right to Access and/or Take Your Data: You can ask us for a copy of your personal data and can ask for a copy of personal data you provided in machine readable
                                    form.
                                </li>
                            </p>
                        </ul>
                        <p> Subscribers to our marketing mailing list can unsubscribe at any time by clicking the &quot;unsubscribe&quot; button within our emails. </p>
                        <p>
                            {' '}
                            Without prejudice to any other rights you may have, you may file a complaint with the Irish Data Protection Commissioner, which is our supervisory authority. You can
                            contact the Commissioner at:
                            {' '}
                        </p>
                        <p>Canal House, Station Road, Portarlington, R32 AP23 Co. Laois Tel: 1890 252 231</p>
                        <p>
                            <a href="http://www.dataprotection.ie/">www.dataprotection.ie</a>
                        </p>
                        <p>
                            {' '}
                            If you would like to exercise any of your rights or you have any questions about your rights please contact us using the contact form on our website, which is linked to
                            below under term 14.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 10. Third-party Advertisers </h3>
                        <p>
                            <em>
                                {' '}
                                We hear you; online ads can be a real pain. At Noa we wanted to find a way to offer ads that were both user-friendly and
                                {' '}
                                <strong>enjoyable to engage with</strong>
                                . And
                                for those who would rather not engage, we wanted to ensure that any ads present on the Noa service did not take from your overall user experience. The simple fact of
                                the matter is that producing high-quality journalism is a very expensive business. On the other hand, we don’t believe that you want to pay a colossal premium in order
                                to consume such quality news, insight, and analysis. That’s why we have done our very best to provide ads that we ourselves are happy to consume. The benefit for all
                                Subscribers and users is that the price of a Noa Subscription is greatly reduced as a result. Companies that advertise do help to keep the wheels of our economy in
                                motion, so do think of them over similar sized rivals when making purchasing decisions.
                                {' '}
                            </em>
                        </p>
                        <p>
                            {' '}
                            There are two types of advertisements offered on the Noa Service. These are background display ads (as offered on the article play screen) and concise audio ads (as offered
                            between articles from time-to-time) (the &quot;Adverts&quot;). In both instances Noa records and shares in aggregated form the Usage Data related to the Adverts with third-party
                            advertising clients. Noa does not share any Personal Information with third-party advertisers. Any information shared with third-party advertisers is in an aggregated
                            format and is strictly non-personally-identifiable.
                            {' '}
                        </p>
                        <p> We accept no responsibility for the content of advertising material, including any error, omission or inaccuracy contained within it. </p>
                        <h3 className={css(styles.sectionTitle)}> 11. Our Commitment to Data Security </h3>
                        <p>
                            {' '}
                            Noa uses commercially reasonable physical, managerial, and technical safeguards to preserve the integrity and security of your Personal Information. We cannot, however,
                            ensure or warrant the security of any information you transmit to Noa and you do so at your own risk. Using unsecured Wi-Fi or other unprotected networks to supply Personal
                            Information to Noa is never recommended. Once we receive your transmission of information, Noa makes commercially reasonable efforts to ensure the security of our systems.
                            However, please note that this is not a guarantee that such information may not be accessed, disclosed, altered, or destroyed by breach of any of our physical, technical,
                            or managerial safeguards. If Noa learns of a security systems breach, then we may attempt to notify you electronically so that you can take appropriate protective steps.
                            Noa may post a notice on the Noa Site or through the Noa Service if a security breach occurs.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 12. Special Note to International Users </h3>
                        <p>
                            {' '}
                            The Noa Service is hosted in Ireland. If you are a user accessing the Noa Service from outside of the European Union, or any other region with laws or regulations governing
                            personal data collection, use, and disclosure, that differ from European Union laws, please be advised that through your continued use of the Noa Services, which are
                            governed by Irish law, this Privacy Policy, and our Terms and Conditions of Use, you are transferring your personal information to the European Union and you expressly
                            consent to that transfer and consent to be governed by Irish law for these purposes.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 13. In the Event of Merger, Sale, or Bankruptcy </h3>
                        <p>
                            {' '}
                            In the event that Noa is acquired by or merged with a third party entity, we reserve the right to transfer or assign the information we have collected from our users as
                            part of such merger, acquisition, sale, or other change of control. In the unlikely event of our bankruptcy, insolvency, reorganization, receivership, or assignment for the
                            benefit of creditors, or the application of laws or equitable principles affecting creditors&apos; rights generally, we may not be able to control how your Personal Information
                            is treated, transferred, or used.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 14. Changes and updates to this Privacy Notice </h3>
                        <p>
                            {' '}
                            This Privacy Policy may be revised periodically and this will be reflected by the &quot;effective date&quot; above. Please revisit this document on the Noa website to stay aware of
                            any changes. Your continued use of the Noa Service constitutes your agreement to this Privacy Policy and any amendments. This document is effective from 25
                            <sup>
                                th
                            </sup>
                            {' '}
                            October 2018.
                            {' '}
                        </p>
                        <h3 className={css(styles.sectionTitle)}> 15. Contacting Us </h3>
                        <p> If you have any questions regarding this Privacy Statement or our use of your personal information, please contact us using the following information: </p>
                        <p>
                            {' '}
                            Email:
                            {' '}
                            <a href="mailto:feedback@newsoveraudio.com">feedback@newsoveraudio.com</a>
                        </p>
                        <p> Postal address: Noa News Limited, DIT Hothouse Centre, Greenway Hub, DIT Grangegorman, Dublin 7, Ireland. </p>
                    </View>
                </Container>

                {!!this.props.showSitemap && <LandingPageNewSitemap />}
            </Page>
        );
    }
}

const styles = StyleSheet.create({
    page: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 15,
            paddingTop: 25,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 14,
        },
        backgroundColor: newtheme.darkmodeColors.backgroundNavy,
        color: newtheme.darkmodeColors.slightlyFadedText,
        fontSize: 17,
        paddingTop: 50,
        paddingBottom: 150,
    },
    personalInfoTable: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 13,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 11,
        },
        marginTop: 25,
        fontSize: 14,
    },
    tableCellVerticalAlign: {
        verticalAlign: 'top',
    },
    title: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 30,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 25,
        },
        fontSize: 35,
        marginTop: 0,
        marginBottom: 25,
        color: newtheme.darkmodeColors.white,
    },
    sectionTitle: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 23,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 21,
        },
        fontSize: 25,
        marginTop: 50,
        color: newtheme.darkmodeColors.white,
    },
    sectionSubTitle: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 16,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 15,
        },
        fontSize: 18,
        marginTop: 35,
    },
    sectionSmallSubTitle: {
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 15,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 14,
        },
        fontSize: 17,
        marginTop: 30,
    },
    tableHeader: {
        [`@media (max-width: ${theme.breakpoints.medium}px)`]: {
            whiteSpace: 'normal',
            minWidth: 150,
        },
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            minWidth: 125,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            minWidth: 115,
            paddingRight: 5,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            minWidth: 110,
            paddingRight: 0,
        },
        whiteSpace: 'nowrap',
        paddingRight: 10,
        verticalAlign: 'top',
    },
});

export default Privacy;
